/*
 * MDB shim for MDBTable
 * Files currently importing this symbol from "mdbreact":
 * - src/Seating/Accounts/accountList.jsx
 * - src/Seating/Patient/PatientViewComponents/CreateQuoteModalFromTicket.jsx
 * - src/Seating/Patient/patientOrderView.jsx
 * - src/Seating/PurchaseQueue/inventoryRequest.jsx
 * - src/Seating/PurchaseQueue/inventoryRequestTable.jsx
 * - src/Seating/PurchaseQueue/purchaseQueueTable.jsx
 * - src/Seating/Settings/creditCardTypes.jsx
 * - src/Seating/Settings/deliveryAcknowledgements.jsx
 * - src/Seating/Settings/editProductSubTypes.jsx
 * - src/Seating/Settings/expenseTypes.jsx
 * - src/Seating/Settings/reasons.jsx
 * - src/Seating/Settings/trainingLink.jsx
 */

import MUITable from "@mui/material/Table";

export default function MDBTable({ children, ...rest }) {
  return <MUITable {...rest}>{children}</MUITable>;
}
